<template>
  <svg
    id="controlBox"
    class="control-box"
    x="50"
    y="50"
    width="250"
    :height="25 * 8"
  >
    <rect
      class="control-box__wrap"
      :width="75"
      :height="40"
      :x="85"
      :y="25"
      :rx="6"
    />
    <image
      v-if="canEdit"
      class="control-box__icon"
      :width="16"
      :height="16"
      :x="100"
      :y="37"
      xlink:href="../assets/icons/edit.svg"
      @click="edit()"
    />
    <image
        class="control-box__icon"
        :width="16"
        :height="16"
        :x="130"
        :y="37"
        xlink:href="../assets/icons/trash.svg"
        @click="remove()"
      />
  </svg>
</template>

<script>
export default {
  name: 'VControlBox',
  props: {
    canEdit: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    edit() {
      this.$emit('edit')
    },
    remove() {
      this.$emit('remove')
    }
  }
}
</script>

<style lang="scss" scoped>
.control-box {
  &__wrap {
    //fill: #fff;
    /*stroke: #000000;*/
  }

  &__icon {
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/VControlBox.vue